import React from 'react'
import Icon from './Icon'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError() {
    // Mettre à jour l'état pour afficher l'UI d'erreur
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // Log l'erreur pour le débogage
    console.error('Erreur capturée par ErrorBoundary:', error, errorInfo)
    this.setState({ error, errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-canvas p-4">
          <div className="w-full max-w-md">
            <div className="card p-6">
              <span className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-negative-subtle text-negative">
                <Icon name="alert" size={20} />
              </span>
              <h1 className="text-xl font-semibold text-ink">Un problème est survenu</h1>
              <p className="mt-1.5 text-base text-ink-secondary">
                L’application n’a pas pu s’afficher correctement. Recharger la page suffit le plus
                souvent à repartir.
              </p>

              {this.state.error && (
                <details className="mt-4">
                  <summary className="cursor-pointer text-sm text-ink-muted transition-colors duration-fast hover:text-ink">
                    Détails techniques
                  </summary>
                  {/* Bloc scrollable dans son propre conteneur : une pile
                      d'appels ne doit pas faire déborder la page. */}
                  <pre className="mt-2 max-h-48 overflow-auto rounded-md border border-line bg-surface-sunken p-3 text-xs text-ink-secondary">
                    {this.state.error.toString()}
                    {this.state.errorInfo?.componentStack}
                  </pre>
                </details>
              )}

              <button
                type="button"
                onClick={() => {
                  this.setState({ hasError: false, error: null, errorInfo: null })
                  window.location.reload()
                }}
                className="btn-primary btn-block mt-5"
              >
                <Icon name="refresh" size={16} />
                Recharger la page
              </button>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
